import React from "react";
import {
  Box,
  Typography,
  Avatar,
  IconButton,
  Divider,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MessageIcon from "@mui/icons-material/Message";

interface SenderInfoPanelProps {
  sender: {
    id: number;
    name: string;
    avatar?: string;
  };
  onClose: () => void;
  onMessageClick: () => void;
  chatType: "individual" | "group";
  isDesktop: boolean;
}

export const SenderInfoPanel: React.FC<SenderInfoPanelProps> = ({
  sender,
  onClose,
  onMessageClick,
  chatType,
  isDesktop,
}) => {
  return (
    <Box
      sx={{
        position: isDesktop ? "relative" : "fixed",
        top: 0,
        right: 0,
        width: isDesktop ? "100%" : "100vw",
        height: "100%",
        bgcolor: "background.paper",
        zIndex: isDesktop ? 1 : 1300,
        boxShadow: isDesktop ? "none" : 3,
        overflowY: "auto",
      }}
    >
      {!isDesktop && (
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", top: 16, left: 16 }}
        >
          <ArrowBackIcon />
        </IconButton>
      )}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          p: 2,
          borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
        }}
      >
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <Typography variant="h6" sx={{ ml: 2, flexGrow: 1 }}>
          {chatType === "individual" ? "Contact Info" : "Group Member Info"}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          py: 4,
          px: 2,
        }}
      >
        <Avatar src={sender.avatar} sx={{ width: 120, height: 120, mb: 2 }}>
          {sender.name[0]}
        </Avatar>
        <Typography variant="h5" gutterBottom>
          {sender.name}
        </Typography>

        <IconButton
          onClick={onMessageClick}
          sx={{
            mt: 2,
            bgcolor: "primary.main",
            color: "white",
            "&:hover": {
              bgcolor: "primary.dark",
            },
          }}
        >
          <MessageIcon sx={{ mr: 1 }} />
          <Typography variant="body1">
            Message {sender.name.split(" ")[0]}
          </Typography>
        </IconButton>
      </Box>

      <Divider />

      <Box sx={{ p: 2, flexGrow: 1 }}>
        <Typography variant="subtitle1" gutterBottom>
          Information
        </Typography>
        <List>
          <ListItem>
            <ListItemText primary="Status" secondary="Online" />
          </ListItem>
          <ListItem>
            <ListItemText primary="Member Since" secondary="Jan 2023" />
          </ListItem>
        </List>
      </Box>
    </Box>
  );
};
